import React from 'react';
import MediaQuery from 'react-responsive';
import { Parallax } from 'react-parallax';

const Header = props => (
  <div id="head">
    <Parallax blur={0} bgImage={props.img} bgImageAlt={props.title} strength={120}>
      <MediaQuery query="(max-width: 576px)">
        <div style={{ height: '250px' }} />
      </MediaQuery>
      <MediaQuery query="(min-width: 577px) and (max-width: 768px)">
        <div style={{ height: '350px' }} />
      </MediaQuery>
      <MediaQuery query="(min-width: 769px) and (max-width: 991px)">
        <div style={{ height: '450px' }} />
      </MediaQuery>
      <MediaQuery query="(min-width: 992px)">
        <div style={{ height: '600px' }} />
      </MediaQuery>
    </Parallax>
    <div className="container">
      <div className="row">
        <h1 id="title">{props.title}</h1>
      </div>
    </div>
  </div>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js